var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { dataArrayChunk, NODE_ENV, REACT_APP__URL_EASYPOST_BASE, } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./pageconfig.static";
export class ApiEpPageconfig {
}
_a = ApiEpPageconfig;
ApiEpPageconfig.connect = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/connect`,
    method: "POST",
}, failureHash).then((resp) => resp[0]);
ApiEpPageconfig.create = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/`,
    method: "POST",
}, failureHash);
ApiEpPageconfig.delete = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/${req.path.id}`,
    method: "DELETE",
}, failureHash);
ApiEpPageconfig.disconnect = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/disconnect`,
    method: "POST",
}, failureHash);
ApiEpPageconfig.list = (req) => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (((_b = req === null || req === void 0 ? void 0 : req.query) === null || _b === void 0 ? void 0 : _b.medium_external_id__in) &&
        !req.query.medium_external_id__in.length) {
        return {
            next: null,
            previous: null,
            results: [],
        };
    }
    if (((_c = req === null || req === void 0 ? void 0 : req.query) === null || _c === void 0 ? void 0 : _c.id__in) && !req.query.id__in.length) {
        return {
            next: null,
            previous: null,
            results: [],
        };
    }
    const chunkField = ((_f = (_e = (_d = req === null || req === void 0 ? void 0 : req.query) === null || _d === void 0 ? void 0 : _d.medium_external_id__in) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 100
        ? "medium_external_id__in"
        : ((_j = (_h = (_g = req === null || req === void 0 ? void 0 : req.query) === null || _g === void 0 ? void 0 : _g.id__in) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : 0) > 100
            ? "id__in"
            : undefined;
    if (!chunkField) {
        return apiRequest({
            endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/`,
            method: "GET",
            next: req === null || req === void 0 ? void 0 : req.next,
            query: req === null || req === void 0 ? void 0 : req.query,
        }, failureHash);
    }
    const chunks = dataArrayChunk(((_k = req === null || req === void 0 ? void 0 : req.query) === null || _k === void 0 ? void 0 : _k[chunkField]) || [], 100);
    const chunksResults = yield Promise.all(chunks.map((chunk) => __awaiter(void 0, void 0, void 0, function* () {
        var _l;
        const query = Object.assign(Object.assign({}, req === null || req === void 0 ? void 0 : req.query), { [chunkField]: chunk });
        let results = [];
        let next;
        do {
            const responseChunk = yield apiRequest({
                endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/`,
                method: "GET",
                next,
                query,
            }, failureHash);
            results = [...results, ...responseChunk.results];
            next = (_l = responseChunk.next) !== null && _l !== void 0 ? _l : undefined;
            if (NODE_ENV === "development" && next) {
                next = next.replace("https://staging.smmplanner.com/", REACT_APP__URL_EASYPOST_BASE);
            }
        } while (next);
        return results;
    })));
    return {
        next: null,
        previous: null,
        results: chunksResults.flat(),
    };
});
ApiEpPageconfig.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/${req.path.id}`,
    method: "GET",
}, failureHash);
ApiEpPageconfig.update = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/${req.path.id}`,
    method: "PUT",
}, failureHash);
ApiEpPageconfig.updatePartial = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v2/pageconfig/${req.path.id}`,
    method: "PATCH",
}, failureHash);
//# sourceMappingURL=pageconfig.js.map